import { ValidationInputType } from "@cak-legacy/generation-core";
import { AbstractValidation, CustomErrorMessage } from "@cak-legacy/generation-form";

import { stringToFloat } from "./number";

export class HasMaximalAmountValidation extends AbstractValidation {
  key = "hasMaximalAmount";

  constructor(public readonly maximalAmount: number, customErrorMessage?: CustomErrorMessage) {
    super(customErrorMessage);
  }

  validate = (value: ValidationInputType) => {
    if (!value) {
      return true;
    }

    const valueToCheck = stringToFloat(value as unknown as string) || Number.MAX_VALUE;
    return valueToCheck <= this.maximalAmount;
  };

  defaultMessage = (label: string): string =>
    `'${label}' getal moet maximaal ${this.maximalAmount} of lager zijn.`;
}
